import { useSectionContent } from "@/hooks/useContent";

export default function Footer() {
  const { tagline } = useSectionContent("footer");
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#C5A059]/20 bg-[#0A0A0B] py-12 px-5 sm:px-8"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img
            src="/logo-cutout.png"
            alt="Logo Neapolis Free Chapter"
            className="h-12 w-12 object-contain [filter:drop-shadow(0_0_10px_rgba(197,160,89,0.4))]"
          />
          <div className="leading-tight">
            <p className="font-display font-bold text-sm text-[#F4EBE1]">NEAPOLIS FREE CHAPTER</p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#78746D]">
              BIKES'N'FUN · EST. 2019
            </p>
          </div>
        </div>
        <p className="font-mono text-[11px] text-[#78746D] tracking-[0.15em] text-center">
          {tagline}
        </p>
      </div>
    </footer>
  );
}
